import type { ApiError } from "@/types";

export type ErrorKind = "network" | "rate_limited" | "auth" | "not_found" | "unavailable" | "other";

/** What kind of failure an API error is, for picking the fallback UI. */
export function errorKind(err: ApiError): ErrorKind {
  if (err.error === "NETWORK_ERROR") return "network";
  if (err.status === 429 || err.error === "RATE_LIMIT_ERROR") return "rate_limited";
  if (err.error === "EZYVET_AUTH_ERROR" || err.status === 403) return "auth";
  if (err.status === 404) return "not_found";
  if (err.status === 405 || err.status === 501) return "unavailable";
  return "other";
}
